module.exports = __webpack_public_path__ + "img/default-product.e0e560ac.png";